var React = require('react');

function IconArrowDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18.44 12.44l-5.69 5.69V3h-1.5v15.13l-5.7-5.69L4.5 13.5 12 21l7.5-7.5-1.06-1.06z"}));
}

IconArrowDown.defaultProps = {"fill":"currentColor","aria-hidden":"true","focusable":"false","viewBox":"0 0 24 24"};

module.exports = IconArrowDown;

IconArrowDown.default = IconArrowDown;
